import { render, staticRenderFns } from "./CargarDialogDescripcionNomina.vue?vue&type=template&id=716ef961&"
import script from "./CargarDialogDescripcionNomina.vue?vue&type=script&lang=js&"
export * from "./CargarDialogDescripcionNomina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports